import React from "react";
import { useSelector } from "react-redux";
import {
  selectAllApartments,
  selectAllContent,
  selectIsLoading,
} from "../../features/apartments/selectors";
import { ContactForm } from "../../components/ContactForm";
import {
  StyledImageContainer,
  StyledHeroGradient,
} from "../../components/HeroHeader/styled";
import "./style.css";
import { imagesResponse } from "../../api/responses";
import { Loader } from "lucide-react";
import { Seo } from "../../components/Seo";
import { PageShell } from "../../components/PageShell";
import { useInitApp } from "../../hooks/useInitApp";

export const ContactPage = () => {
  const content = useSelector(selectAllContent);
  const data = useSelector(selectAllApartments);
  const isLoading = useSelector(selectIsLoading);

  useInitApp();

  const hasContent = (content?.length ?? 0) > 0;
  if (isLoading && !hasContent) return <Loader />;

  return (
    <>
      <Seo
        title="Contatti"
        description="Contatta Isola Dei Mori per informazioni, disponibilità e prenotazioni."
      />
      <PageShell>
        <div className="main-container-contacts">
          {/* Hero image */}
          <StyledImageContainer src={content?.[0]?.url || imagesResponse[0].url} />
          <StyledHeroGradient className="hero-image-contacts" />

          {/* Contact form */}
          <div className="form-container">
            <ContactForm />
          </div>
        </div>
      </PageShell>
    </>
  );
};
